import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import VueGtag from "vue-gtag";
createApp(App).use(VueGtag, {
  config: { id: "G-M92Q7MS758" }
}).mount("#app");